/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';
import { Countries } from './countries.service';

@Injectable({ providedIn: 'root' })
export class UserContactPermissions {
  constructor(private cs: Countries) {}

  private contactConsentRegions = new Set(['Other Europe', 'Rest of the World']);

  private contactConsentCountries = new Set([
    'AUT',
    'BEL',
    'BGR',
    'HRV',
    'CZE',
    'DNK',
    'EST',
    'FIN',
    'FRA',
    'DEU',
    'GRC',
    'HUN',
    'IRL',
    'ITA',
    'LVA',
    'LTU',
    'LUX',
    'MLT',
    'NLD',
    'POL',
    'PRT',
    'ROU',
    'SVK',
    'SVN',
    'ESP',
    'SWE',
    'GBR',
  ]);

  shouldAskConsent(countryLabel: string) {
    if (!countryLabel) return false;

    if (this.contactConsentRegions.has(countryLabel)) return true;

    const country = this.cs.countries.find((c) => c.label === countryLabel);

    if (!country) return false;

    return this.contactConsentCountries.has(country.code);
  }
}
